const encerrar_no_letivo_por_aluno = [
  {
    path: "/encerrar-ano-letivo-por-aluno",
    name: "encerrar_no_letivo_por_aluno",
    meta: {
      allowedPermissions: ["encerrar_ano_letivo_aluno"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () =>
      import("@/views/EncerrarAnoLetivoPorAluno/EncerrarAnoLetivoPorAluno.vue"),
  },
];

export { encerrar_no_letivo_por_aluno };
